<script lang="ts">
  import { onMount } from 'svelte';
  import Header from './components/Header.svelte';
  import DevToolsDrawer from './components/DevToolsDrawer.svelte';
  import { identity } from './lib/identity.svelte';
  import { route } from './lib/router.svelte';
  import { installLiveCatalogueRefresh } from './lib/catalogue-store.svelte';

  const isDev = import.meta.env.DEV;
  import Dashboard from './routes/Dashboard.svelte';
  import Catalogue from './routes/Catalogue.svelte';
  import Changes from './routes/Changes.svelte';
  import History from './routes/History.svelte';
  import Governance from './routes/Governance.svelte';
  import Guide from './routes/Guide.svelte';
  import NotFound from './routes/NotFound.svelte';
  import AccessGate from './routes/AccessGate.svelte';

  const current = $derived(route.current);
  const accessBlocked = $derived(
    !identity.loading && (identity.error === 'cloudflare_access_header_missing' || identity.not_provisioned)
  );

  onMount(() => {
    // Re-fetch the manifest (and any cached live catalogues whose
    // in-effect git_hash has changed) every time the tab regains
    // visibility. Closes the "user stays on the page during a merge"
    // stale-cache gap that PR #51 left open for the navigate-back
    // pattern only. See catalogue-store.svelte for the full rationale.
    installLiveCatalogueRefresh();
  });
</script>

<div class="app-shell">
  <Header />

  <main class="app-main">
    {#if identity.loading}
      <p class="muted">Authenticating…</p>
    {:else if accessBlocked}
      <AccessGate />
    {:else if identity.error}
      <div class="banner banner-fail">
        Could not load identity: {identity.error}.
      </div>
    {:else}
      {#if current.name === 'dashboard'}
        <Dashboard />
      {:else if current.name === 'catalogue'}
        <Catalogue />
      {:else if current.name === 'changes'}
        <Changes />
      {:else if current.name === 'history'}
        <History />
      {:else if current.name === 'governance'}
        <Governance />
      {:else if current.name === 'guide'}
        <Guide />
      {:else}
        <NotFound />
      {/if}
    {/if}
  </main>

  {#if isDev}
    <DevToolsDrawer />
  {/if}
</div>
